// extracted by mini-css-extract-plugin
export default {"spinner":"rotating-spinner_spinner__aaLMw","blackSpinner":"rotating-spinner_blackSpinner__i0KlA"};